(function () {
    'use strict';

    angular
        .module('app')
        .controller('ViewItemUsageDialog', ViewItemUsageDialog);

    ViewItemUsageDialog.$inject = ['DialogInstance', 'itemIds', 'ItemService'];

    /**
     * @ngdoc controller
     * @name ViewItemUsageDialog
     *
     * @description
     * Dialog for showing the items usages
     *
     * @param {object} itemIds - The item ids for which usage will be shown
     */
    function ViewItemUsageDialog(DialogInstance, itemIds, itemService) {
        /* jshint validthis:true */
        var vm = this;
        vm.currentPage = 1;
        vm.pageSize = 10;
        vm.showParents = false;
        vm.showErrors = false;
        vm.hasErrors = false;
        vm.loading = false;
        vm.successful = false;
        vm.itemUsages = [];
        vm.getItemTypeLabel = getItemTypeLabel;
        vm.getItemUsages = getItemUsages;
        vm.getItemUsagesCount = getItemUsagesCount;
        vm.disableOk = disableOk;
        vm.close = close;
        vm.deleteItems = deleteItems;

        vm.recordTypes = [
            { value: 'DashboardSetting', description: 'Dashboard Panel', iconUsage: 'home' },
            { value: 'DocumentTemplate', description: 'Document Template', iconUsage: 'document template' },
            { value: 'Email', description: 'Email', iconUsage: 'email' },
            { value: 'EmailAddressCache', description: 'Email Address Cache', iconUsage: 'email address cache' },
            { value: 'EmailTemplate', description: 'Email Template', iconUsage: 'email template' },
            { value: 'Entity', description: 'Entity', iconUsage: 'entity' },
            { value: 'EntityTemplate', description: 'Entity Template', iconUsage: 'entity template' },
            { value: 'File', description: 'File', iconUsage: 'file' },
            { value: 'Note', description: 'Note', iconUsage: 'note' },
            { value: 'SMS', description: 'SMS', iconUsage: 'sms' },
            { value: 'SMSTemplate', description: 'SMS Template', iconUsage: 'sms template' },
            { value: 'Task', description: 'Task', iconUsage: 'task' },
            { value: 'WorkflowDefinition', description: 'Workflow Definition', iconUsage: 'workflow' },
            { value: 'WorkflowInstance', description: 'Workflow Instance', iconUsage: 'history' }
        ];

        activate();

        function activate() {
            vm.loading = true;

            itemService.getUsage(itemIds)
                .then(getUsageOk, getUsageError);
        }

        function getUsageOk(result) {
            vm.itemUsages = result;

            _.forEach(vm.itemUsages, function (itemUsage) {
                formatItemForView(itemUsage);
            });

            if (_.some(vm.itemUsages, function (itemUsage) {
                return !_.isNil(itemUsage.Errors) && itemUsage.Errors.length > 0;
            })) {
                vm.showErrors = true;
                vm.hasErrors = true;
            }

            vm.loading = false;
        }

        function getUsageError(response) {
            vm.error = 'Error loading objects.';
            vm.loading = false;
        }

        function getItemUsages() {
            return _.slice(getFilteredItemUsages(), (vm.currentPage - 1) * vm.pageSize, vm.currentPage * vm.pageSize);
        }

        function getItemUsagesCount() {
            return getFilteredItemUsages().length;
        }

        function getFilteredItemUsages() {
            return _.filter(vm.itemUsages, function (itemUsage) {
                return (_.isNil(vm.searchDescription) || itemUsage.Description.toLowerCase().includes(vm.searchDescription.toLowerCase())) &&
                    (_.isNil(vm.searchRecordType) || vm.searchRecordType === '' || vm.searchRecordType === itemUsage.Type) &&
                    (vm.showErrors === false || (!_.isNil(itemUsage.Errors) && itemUsage.Errors.length > 0)) &&
                    (vm.showParents === false || _.some(itemIds, function (itemId) { return itemId === itemUsage.Id; }));
            });
        }

        function close() {
            DialogInstance.cancel();
        }

        function getItemTypeLabel(item) {
            var result = item.Type;

            switch (item.Type) {
                case 'DocumentTemplate':
                    result = 'Document Template';
                    break;
                case 'EmailAddressCache':
                    result = 'Email Address Cache';
                    break;
                case 'EmailTemplate':
                    result = 'Email Template';
                    break;
                case 'Entity':
                    result = !_.isNil(item.EntityTemplateName) ? item.EntityTemplateName : 'Entity';
                    break;
                case 'EntityTemplate':
                    result = 'Entity Template';
                    break;
                case 'SMSTemplate':
                    result = 'SMS Template';
                    break;
                case 'DashboardSetting':
                    result = 'Dashboard Panel';
                    break;
                case 'WorkflowDefinition':
                    result = 'Workflow Definition';
                    break;
                case 'WorkflowInstance':
                    result = 'Workflow Instance';
                    break;
                default:
                    break;
            }

            return result;
        }

        /**
         * Format an "Item" for viewing. Some properties may be added, others may be modified.
         *
         * @param {object} item - The item to be formatted.
         */
        function formatItemForView(item, includeTypePrefix) {
            item.iconUsage = item.Type;
            item.icon = '';

            if (item.Type === 'SMS') {
                item.iconUsage = '';
                item.icon = 'sms-sent';
            } else if (item.Type === 'Email') {
                if (item.EmailStatus === 'Sent') {
                    item.iconUsage = 'email-sent';
                } else if (item.EmailStatus === 'Received') {
                    item.iconUsage = 'email-received';
                } else if (item.EmailStatus === 'Draft') {
                    item.iconUsage = 'email-draft';
                }
            } else if (item.Type === 'Entity') {
                item.iconUsage = '';
                item.icon = item.EntityTemplateIcon;
                item.iconColour = item.EntityTemplateIconColour;
            } else if (item.Type === 'EntityTemplate') {
                item.iconUsage = 'entity template';
            } else if (item.Type === 'EmailAddressCache') {
                item.iconUsage = 'email address cache';
            } else if (item.Type === 'DocumentTemplate') {
                item.iconUsage = 'document template';
            } else if (item.Type === 'EmailTemplate') {
                item.iconUsage = 'email template';
            } else if (item.Type === 'SMSTemplate') {
                item.iconUsage = 'sms template';
            } else if (item.Type === 'DashboardSetting') {
                item.iconUsage = 'home';
            } else if (item.Type === 'WorkflowDefinition') {
                item.iconUsage = 'workflow';
            } else if (item.Type === 'WorkflowInstance') {
                item.iconUsage = 'history';
            }
        }

        function disableOk() {
            return vm.loading || _.isNil(vm.itemUsages) || vm.itemUsages.length === 0 || vm.hasErrors || vm.successful;
        }

        function deleteItems() {
            delete vm.error;
            vm.loading = true;

            itemService.permanentlyDeleteItems(itemIds)
                .then(deleteItemsOk, deleteItemsError);
        }

        function deleteItemsOk(response) {
            vm.successful = true;
            vm.loading = false;
        }

        function deleteItemsError(error) {
            vm.error = 'Error deleting objects, please try again.';
            vm.loading = false;
        }
    }
})();
